import FondationsServiceModel from '@/models/FondationsServiceModel';
import EntityStatusModel      from '@/models/services/fondations/EntityStatusModel';
import doc                    from '@widesk-core/decorators/doc';

export default class EntityModel extends FondationsServiceModel {
	private declare _tsFilters: {
		'enabled': boolean;
		'dateEnd[after]': string;
		'dateEnd[before]': string;
		'dateEnd[strictly_after]': string;
		'dateEnd[strictly_before]': string;
	};
	
	static get path(): string {
		return '/entities/{?id}';
	}

	@doc.model(EntityStatusModel) declare entityStatus: EntityStatusModel;
}
